import {ModuleConfiguration} from "../router/model/UserPermission";
import {RedirectServiceModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const RedirectServiceModule = new ModuleConfiguration(RedirectServiceModuleName, [
    AngularJsMaterialModuleName
]);